<section class="card-validity-dialog" aria-labelledby="card-validity-title">
  <button type="button" class="card-validity-dialog__close" (click)="close()" aria-label="Close card validity check">
    <lucide-icon name="x" [size]="22" aria-hidden="true"></lucide-icon>
  </button>

  <h1 id="card-validity-title">{{ 'dashboard.verify_card.title' | translate }}</h1>

  <div class="card-validity-dialog__card-preview" aria-hidden="true">
    <img src="https://hotelcard-files.ams3.cdn.digitaloceanspaces.com/media/cardimgs/personal_hotelcard_plain.webp" alt="">
  </div>

  <p class="card-validity-dialog__description">{{ 'dashboard.verify_card.description' | translate }}</p>

  <label for="hotelcard-number" class="card-validity-dialog__label">{{ 'dashboard.verify_card.hotel_card_number' | translate }}</label>
  <hc-input
    inputId="hotelcard-number"
    type="text"
    leftIcon="credit-card"
    [rightIcon]="isCardNumberComplete ? 'check' : ''"
    placeholder="e.g. 712-123-123"
    autocomplete="off"
    [numbersOnly]="true"
    [maxlength]="11"
    [(ngModel)]="cardNumber"
    (ngModelChange)="onCardNumberChange($event)"
    (keyup.enter)="checkMembershipStatus()">
  </hc-input>

  @if (verificationResult) {
    <div class="card-validity-dialog__result" [class.card-validity-dialog__result--valid]="verificationResult === 'valid'" [class.card-validity-dialog__result--invalid]="verificationResult !== 'valid'" role="status">
      <div class="card-validity-dialog__result-icon">
        <lucide-icon [name]="verificationResult === 'valid' ? 'check' : 'circle-off'" [size]="26" aria-hidden="true"></lucide-icon>
      </div>
      <div>
        <strong>{{ resultTitle }}</strong>
        <p>{{ resultMessage }}</p>
      </div>
    </div>
  }

  <div class="card-validity-dialog__actions">
    <hc-button variant="secondary" leftIcon="arrow-left" (clicked)="close()">{{ 'dashboard.verify_card.back_button_text' | translate }}</hc-button>
    @if (!verificationResult) {
      <hc-button variant="primary" [fullWidth]="true" [disabled]="!isCardNumberComplete" [loading]="isChecking" (clicked)="checkMembershipStatus()">
        {{ 'dashboard.verify_card.membership_status_button_text' | translate }}
      </hc-button>
    }
  </div>
</section>
